import React from 'react';

import Contacts from './contacts';
import DealField from 'bundles/apex/deals/form/fields/field';

function DealSellers(props) {
  return <Contacts {...props} role="seller" />;
}

export default DealField(DealSellers, 'seller');
